import { CommonModule } from '@angular/common';
import { ProctoringCandidatesComponent } from '../proctoring-candidates/proctoring-candidates.component';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ProctoringService } from '@edtech-ui/core/services/proctoring-dashboard/proctoring.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { AssessmentProctoringPolicyBinding } from '@edtech-ui/core/models/proctoring-dashboard-models/get-assessment-by-id';


@Component({
	selector: 'app-proctoring-assessment-detail-page',
	standalone: true,
	imports: [CommonModule, RouterModule, ProctoringCandidatesComponent,
		CommonModule, RouterModule, FormsModule, MatProgressSpinnerModule, ReactiveFormsModule
	],
	templateUrl: './proctoring-assessment-detail-page.component.html',
	styleUrl: './proctoring-assessment-detail-page.component.scss'
})
export class ProctoringAssessmentDetailPageComponent implements OnInit, OnDestroy {

	activeTab: 'overview' | 'candidates' | 'sessions' = 'overview';
	isLoading = false;
	subscription = new Subscription();
	policyBindingData: AssessmentProctoringPolicyBinding | null = null;
	policyBindingId = '';

	constructor(
		private route: ActivatedRoute,
		private proctoringService: ProctoringService,
		private toastr: ToastrService
	) { }


	ngOnInit(): void {
		this.policyBindingId = this.route.snapshot.paramMap.get('policyBindingId') || '';
		if (this.policyBindingId) {
			this.getProctoringAssessmentById();
		}
	}


	getProctoringAssessmentById() {
		this.isLoading = true;
		this.subscription.add(
			this.proctoringService.getProctoringAssessmentById(this.policyBindingId).pipe(
				tap(response => {
					if (response.success) {
						this.policyBindingData = response.data;
					} else {
						this.toastr.error(response.message);
					}
				}),
				finalize(() => {
					this.isLoading = false;
				}),
				catchError(() => {
					return of(null);
				})
			).subscribe()
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
